
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LacadosSection from '../../components/feature/LacadosSection';
import MaderasSection from '../../components/feature/MaderasSection';
import PiedrasNaturalesSection from '../../components/feature/PiedrasNaturalesSection';
import PiedrasCompactasSection from '../../components/feature/PiedrasCompactasSection';
import PorcelanicosSection from '../../components/feature/PorcelanicosSection';
import ResinasMineralesSection from '../../components/feature/ResinasMineralesSection';

export default function MaterialesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-white min-h-screen flex items-center">
        <div className="w-full mx-auto text-center" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
          <h1 
            className="font-light text-gray-900" 
            style={{ 
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(2.5rem, 5vw, 7rem)',
              marginBottom: 'clamp(1rem, 2vh, 3rem)'
            }}
          >
            MATERIALES
          </h1>
          <p 
            className="text-gray-900 max-w-[1400px] mx-auto leading-relaxed" 
            style={{ 
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(1rem, 1.2vw, 2rem)',
              padding: '0 clamp(1rem, 2vw, 3rem)'
            }}
          >
            Descubre nuestra amplia gama de materiales de alta calidad. Desde lacados resistentes hasta maderas naturales, cada material está cuidadosamente seleccionado para ofrecer durabilidad, belleza y funcionalidad en tu baño.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full" style={{ padding: 'clamp(2rem, 3vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>

        {/* Maderas Section */}
        <MaderasSection />
        
        {/* Lacados Section */}
        <LacadosSection />

        {/* Piedra Natural Section */}
        <PiedrasNaturalesSection />

        {/* Piedra Compacta Section */}
        <PiedrasCompactasSection />

        {/* Piedra Compacta Section */}
        <PorcelanicosSection />

        {/* Piedra Compacta Section */}
        <ResinasMineralesSection />

      </div>

      <Footer />
    </div>
  );
}
